// import React, { Fragment, useState } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { connect } from 'react-redux';
// import { logout } from '../actions/auth';
// import icon from '../assets/icon.png';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min';

// const Navbar = ({ logout, isAuthenticated }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleLogout = () => {
//     alert("Signing you out of your session");
//     logout();
//     navigate('/login');
//   };

//   const isActive = (path) =>
//     location.pathname === path
//       ? { fontWeight: '600', fontSize: '1rem', color: '#000000' }
//       : { fontWeight: '500', color: '#f0ffff' };

//   const guestLinks = () => (
//     <Fragment>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/login')} to="/login">
//           Login
//         </Link>
//       </li>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/signup')} to="/signup">
//           Sign Up
//         </Link>
//       </li>
//     </Fragment>
//   );

//   const authLinks = () => (
//     <Fragment>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/systems')} to="/systems">
//           View Systems
//         </Link>
//       </li>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/geofence')} to="/geofence">
//           Geofence
//         </Link>
//       </li>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/probelocation')} to="/probelocation">
//           Soil Probe Locations
//         </Link>
//       </li>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/probes')} to="/probes">
//           Soil Probe Graphs
//         </Link>
//       </li>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/maps')} to="/maps">
//           Historic Maps
//         </Link>
//       </li>
//       <li className="nav-item">
//         <Link className="nav-link" style={isActive('/livemaps')} to="/livemaps">
//           Live Maps
//         </Link>
//       </li>
//       <li className="nav-item">
//         <button
//           className="nav-link btn btn-link"
//           style={{ fontWeight: 'bold', color: '#F7C200' }}
//           onClick={handleLogout}
//         >
//           Log Out
//         </button>
//       </li>
//     </Fragment>
//   );

//   return (
//     <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#3863a0' }}>
//       <Link className="navbar-brand" to="/">
//         <img src={icon} alt="App Logo" style={{ width: '70px', height: 'auto', marginLeft: '10px' }} />
//       </Link>
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarNav"
//           aria-controls="navbarNav"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>
//       <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
//         <ul className="navbar-nav">
//           {isAuthenticated ? authLinks() : guestLinks()}
//         </ul>
//       </div>
//     </nav>
//   );
// };

// const mapStateToProps = state => ({
//   isAuthenticated: state.auth.isAuthenticated
// });

// export default connect(mapStateToProps, { logout })(Navbar);

// // FOR BACKEND ONLY, DO NOT WANT CUSTOMERS LOGGING INTO THE BACKEND!
import React from 'react';

const Navbar = () => {
  return null; // No navbar rendering
};

export default Navbar;
